// Extra translation keys for the ecommerce experience (shop, product, cart,
// checkout, order flow, contact, legal, admin). Merged on top of the main
// `dict` in translations.js by the resolver.

export const ecommerceDict = {
  es: {
    common: {
      back: "Volver",
      continue: "Continuar",
      loading: "Cargando…",
      error_generic: "Ha ocurrido un error. Inténtalo de nuevo.",
      required: "Obligatorio",
      eur: "€",
    },
    nav_ecom: {
      home: "Inicio",
      shop: "Tienda",
      cart: "Carrito",
      contact: "Contacto",
      journal: "Diario",
    },
    shop_page: {
      overline: "Tienda",
      title: "Cosecha temprana",
      subtitle: "Aceite de oliva virgen extra de cosecha temprana. Edición limitada.",
      availability_banner: "Próxima cosecha en preparación · lista de espera disponible.",
      add_to_cart: "Añadir al carrito",
      view_product: "Ver producto",
      out_of_stock: "Agotado",
      low_stock: "Últimas unidades",
      from_price: "Desde",
    },
    product_page: {
      qty: "Cantidad",
      add_to_cart: "Añadir al carrito",
      added: "Añadido al carrito",
      in_stock: "En stock",
      low_stock: "Últimas unidades",
      out_of_stock: "Agotado",
      shipping_info: "Envío en 2-4 días laborables a Península. Embalaje protegido.",
      trust_1: "Edición limitada · cosecha temprana",
      trust_2: "Embalaje reforzado · protección en el transporte",
      trust_3: "Pago seguro · Stripe",
      trust_4: "Trato directo con el productor",
      details_title: "Detalles del producto",
      attributes_title: "Ficha técnica",
      highlights_title: "Claves",
      vat_included: "IVA incluido",
      availability_note: "Próxima cosecha · disponibilidad pendiente de confirmación.",
      bundle_title: "Elige la edición que te interesa",
      bundle_option_box: "Solo caja regalo",
      bundle_option_box_1: "Caja + 1 botella adicional",
      bundle_option_box_2: "Caja + 2 botellas adicionales",
      bundle_summary_prefix: "Tu selección:",
      bundle_micro: "Una para regalar, otra para casa.",
    },
    cart_page: {
      title: "Tu carrito",
      empty_title: "Tu carrito está vacío",
      empty_body: "Explora nuestra tienda y añade productos para empezar.",
      continue_shopping: "Seguir comprando",
      go_shop: "Ir a la tienda",
      item: "Producto",
      price: "Precio",
      qty: "Cantidad",
      subtotal: "Subtotal",
      line_total: "Total línea",
      remove: "Quitar",
      summary: "Resumen",
      shipping: "Envío",
      shipping_calculated: "Se calcula en el siguiente paso",
      total: "Total",
      checkout: "Finalizar compra",
    },
    checkout_page: {
      title: "Datos del pedido",
      subtitle: "Rellena tus datos de envío y elige el método de pago.",
      step_data: "Datos",
      step_payment: "Pago",
      step_confirm: "Confirmación",
      customer_title: "Tus datos",
      name: "Nombre y apellidos",
      email: "Email",
      phone: "Teléfono",
      address_title: "Dirección de envío",
      address1: "Dirección",
      address2: "Piso, puerta, referencia (opcional)",
      city: "Ciudad",
      province: "Provincia",
      postal_code: "Código postal",
      country: "País",
      country_locked_note: "Por el momento, solo podemos enviar pedidos a direcciones de España peninsular.",
      notes: "Notas para el pedido (opcional)",
      payment_title: "Método de pago",
      payment_stripe: "Tarjeta / Apple Pay (Stripe)",
      payment_stripe_desc: "Pago seguro con tarjeta. Apple Pay y Google Pay si están disponibles en tu dispositivo.",
      payment_paypal: "PayPal",
      payment_paypal_desc: "Próximamente.",
      payment_transfer: "Transferencia bancaria",
      payment_transfer_desc: "Te enviamos los datos de ingreso y reservamos tu pedido durante 72 h.",
      summary_title: "Resumen del pedido",
      terms_prefix: "He leído y acepto los ",
      terms_link_aviso: "Términos de uso y Aviso Legal",
      terms_and: " y la ",
      terms_link_privacy: "Política de Privacidad",
      terms_suffix: ". Entiendo que mis datos serán tratados para gestionar mi pedido conforme al art. 6.1.b RGPD.",
      place_order: "Realizar pedido",
      place_order_stripe: "Pagar con tarjeta",
      place_order_transfer: "Confirmar y pagar por transferencia",
      processing: "Procesando…",
      missing_field: "Faltan campos por rellenar.",
      must_accept: "Debes aceptar las condiciones.",
      cart_empty: "Tu carrito está vacío.",
    },
    success_page: {
      title: "¡Gracias por tu pedido!",
      subtitle: "Hemos recibido correctamente tu compra.",
      paid: "Pago confirmado",
      processing: "Estamos confirmando tu pago…",
      failed: "No hemos podido confirmar el pago.",
      order_number: "Número de pedido",
      total: "Total",
      back_home: "Volver al inicio",
      shop_more: "Seguir comprando",
      withdrawal_title: "Derecho de desistimiento",
      withdrawal_body: "Como consumidor, dispones de 14 días naturales desde la recepción del pedido para desistir del contrato.",
      withdrawal_cta: "Ejercer derecho de desistimiento",
      withdrawal_note: "Allí podrás comunicar tu solicitud y recibirás acuse automático por email.",
    },
    transfer_page: {
      title: "Pedido reservado",
      subtitle: "Realiza la transferencia en los próximos 3 días laborables para enviarte el pedido.",
      beneficiary: "Titular",
      iban: "IBAN",
      bic: "BIC / SWIFT",
      concept: "Concepto",
      amount: "Importe",
      note: "Cuando recibamos la transferencia, te enviamos confirmación por email y preparamos el envío.",
    },
    cancelled_page: {
      title: "Pago cancelado",
      subtitle: "No se ha realizado ningún cargo. Puedes volver al carrito y reintentarlo.",
      back_cart: "Volver al carrito",
    },
    contact_page: {
      title: "Contacto",
      subtitle: "Estamos en Limones, Moclín (Granada). Te respondemos el mismo día laborable.",
      write_us: "Escríbenos",
      phone: "Teléfono",
      email: "Email",
      location: "Ubicación",
      hours: "Horario",
      hours_text: "Lunes a viernes · 9:00–18:00",
    },
    blog: {
      overline: "Diario",
      title: "El diario del cortijo",
      subtitle:
        "Notas, guías de cata y protocolo del regalo gourmet. Lecturas breves para disfrutar el AOVE con más criterio.",
      read_more: "Leer artículo",
      read_time_suffix: "de lectura",
      related_title: "Otros artículos del diario",
      all_posts: "Ver todos los artículos",
      back_to_blog: "Volver al diario",
      published_on: "Publicado el",
      updated_on: "Actualizado el",
      cta_title: "¿Quieres probar el AOVE del que te hablamos?",
      cta_body:
        "Edición limitada de cosecha temprana. Botella de 500 ml o caja de madera con motivo del cortijo (2 × 500 ml).",
      cta_shop: "Ir a la tienda",
      cta_product: "Ver la botella 500 ml",
    },
    proof: {
      overline: "El secreto mejor guardado",
      title_a: "Lo que",
      title_b: "respalda",
      title_c: "cada botella",
      body: "Datos concretos que definen cada botella de nuestro olivar familiar en Limones, Moclín.",
      metrics: [
        { k: "< 0,4º", v: "Acidez libre", sub: "Muy por debajo del límite legal del AOVE (0,8º). Verificada por laboratorio antes del embotellado." },
        { k: "< 24 h", v: "De campo a almazara", sub: "Cada aceituna entra al molino el mismo día en que se recoge. Sin atrojados." },
        { k: "< 27 °C", v: "Extracción en frío (menos de 27 °C)", sub: "Temperatura controlada en molturación para preservar polifenoles y aromas." },
        { k: "100 %", v: "Picual", sub: "Una variedad de gran carácter, cultivada en nuestro olivar de Limones, Moclín (Granada)." },
      ],
      credentials_title: "Detalle de producto",
      credentials: [
        "Botella de vidrio oscurecido y protector de 500 ml con tapón dosificador.",
        "Aceituna del árbol, recogida a mano a principios de noviembre.",
        "Molturación en almazara local el mismo día de la recolección.",
        "Origen único: un olivar familiar en Limones, Moclín. Sin mezclas.",
        "Conservar por debajo de 23 °C, protegido de la luz directa.",
        "Consumir preferentemente en los 2 meses siguientes a la apertura · hasta 24 meses bien conservada.",
      ],
      panel_title: "Perfil sensorial · campaña anterior de referencia",
      panel_attrs: [
        { k: "Frutado", v: "Intenso", note: "Verde, herbáceo, con recuerdos de hoja de tomate e higuera." },
        { k: "Amargor", v: "Medio", note: "Amargor noble del picual joven, bien integrado." },
        { k: "Picor", v: "Medio-alto", note: "Limpio y persistente, en el fondo de la garganta tras unos segundos." },
        { k: "Final", v: "Largo", note: "Recuerdo a almendra fresca y memoria herbácea." },
      ],
      panel_disclaimer: "Perfil sensorial del productor · Cortijo Santa María · campaña anterior de referencia. No es una certificación externa. La próxima campaña está pendiente de confirmación.",
    },
    award: {
      alt: "Certificado del premio Sabor Granada 2023 concedido a Cortijo de Santa María como mejor AOVE de producción ecológica",
      overline: "Reconocimiento",
      title: "Premio Sabor Granada 2023",
      body: "Cortijo de Santa María recibió el reconocimiento a Mejor Aceite de Oliva Virgen Extra de Producción Ecológica en la IX edición de los Premios AOVE «Sabor Granada» (2023), concedidos por la Diputación de Granada.",
      cta: "Consultar el certificado del reconocimiento",
      cta_href: "/premio-sabor-granada-2023",
    },
    legal: {
      aviso_title: "Aviso legal",
      privacy_title: "Política de privacidad",
      shipping_title: "Política de envíos",
      returns_title: "Política de devoluciones y desistimiento",
      cookies_title: "Política de cookies",
      back_home: "Volver al inicio",
      last_update: "Última actualización",
      sections: {
        holder: "Titular del sitio",
        holder_body: "Cortijo de Santa María S.C. · CIF: J02704799 · Cortijo de Santa María s/n, 18249 Limones, Moclín (Granada), España · info@cortijodesantamaria.es · +34 626 411 029. Actividad: venta directa al consumidor de aceite de oliva virgen extra de producción propia.",
        aviso_purpose_title: "Objeto y aceptación",
        aviso_purpose: "El presente aviso legal regula el uso del sitio web cortijodesantamaria.com y su tienda online, titularidad de Cortijo Santa María. El acceso y uso del sitio implica la aceptación de estas condiciones. Si no estás de acuerdo, te rogamos que no utilices el sitio.",
        aviso_ip_title: "Propiedad intelectual",
        aviso_ip: "Todos los contenidos del sitio (textos, imágenes, logotipos, marcas, fotografías y elementos gráficos) son propiedad de Cortijo Santa María o se utilizan con autorización. Queda prohibida su reproducción, distribución o modificación sin autorización expresa por escrito.",
        aviso_liability_title: "Responsabilidad",
        aviso_liability: "Hacemos lo razonable para que la información sea exacta y esté actualizada, pero no garantizamos la ausencia de errores tipográficos o de disponibilidad puntual de stock. Los precios se expresan en euros e incluyen IVA salvo indicación contraria; el coste de envío se calcula en el checkout.",
        aviso_jurisdiction_title: "Legislación y jurisdicción",
        aviso_jurisdiction: "Estas condiciones se rigen por la legislación española. Para cualquier controversia, ambas partes se someten a los juzgados y tribunales del consumidor del domicilio del comprador cuando este tenga condición de consumidor.",

        privacy_intro_title: "Quién trata tus datos",
        privacy_intro: "El responsable del tratamiento de tus datos personales es Cortijo Santa María, con domicilio en Limones, Moclín, 18247 Granada (España). Puedes contactar con nosotros en info@cortijodesantamaria.com para cualquier cuestión relativa a tus datos.",
        privacy_purpose_title: "Para qué los usamos",
        privacy_purpose: "Tratamos tus datos únicamente para: (1) gestionar tus pedidos y el proceso de compra, (2) prepararte el envío y comunicarnos contigo sobre el mismo, (3) emitir factura y cumplir nuestras obligaciones fiscales y contables, y (4) responder a las consultas que nos hagas. No realizamos decisiones automatizadas con efecto jurídico ni elaboramos perfiles comerciales.",
        privacy_basis_title: "Base legal",
        privacy_basis: "La base del tratamiento es la ejecución del contrato de compraventa (art. 6.1.b RGPD), el cumplimiento de obligaciones legales (art. 6.1.c RGPD) y, para las comunicaciones analíticas opcionales, tu consentimiento (art. 6.1.a RGPD), que puedes retirar en cualquier momento.",
        privacy_share_title: "Con quién los compartimos",
        privacy_share: "Solo compartimos los datos estrictamente necesarios con: la empresa de transporte para la entrega del pedido, la pasarela de pago Stripe para procesar la compra (procesador certificado PCI-DSS), y nuestro proveedor de infraestructura para alojar la web. Nunca vendemos ni cedemos tus datos a terceros con fines comerciales.",
        privacy_retention_title: "Cuánto los conservamos",
        privacy_retention: "Conservamos los datos de pedido durante el plazo legal exigido por la normativa fiscal y contable (hasta 6 años). Los datos usados para marketing opcional se borran si retiras el consentimiento.",
        privacy_rights: "Puedes ejercer los derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiendo a info@cortijodesantamaria.com, acreditando tu identidad. También puedes presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) si consideras que no hemos atendido correctamente tu solicitud.",

        shipping_scope_title: "Ámbito y plazos",
        shipping_scope: "Debido al nuevo Reglamento de Envases y Residuos de Envases (PPWR, Reglamento (UE) 2025/40), actualmente solo realizamos envíos a España peninsular en 2-4 días laborables desde la confirmación del pago. Los envíos a Baleares, Canarias, Ceuta, Melilla, Portugal continental y resto de la Unión Europea quedan temporalmente suspendidos hasta próximo aviso.",
        shipping_cost_title: "Coste de envío",
        shipping_cost: "El coste de envío se calcula automáticamente en el checkout en función del número de botellas: 5 € para una botella, 8 € para 2 a 5 botellas y 12 € a partir de 6 botellas. Pedidos corporativos o especiales se cotizan aparte.",
        shipping_package_title: "Embalaje",
        shipping_package: "Cada botella viaja enfundada en material protector dentro de una caja reforzada. El estuche regalo viaja también en una sobrecaja adicional. Incluimos precintos antimanipulación.",
        shipping_damage_title: "Incidencias y roturas",
        shipping_damage: "Si recibes el paquete con daños visibles, déjalo constar en el albarán del transportista en el momento de la entrega y escríbenos en las primeras 48 horas a info@cortijodesantamaria.com con fotografías del embalaje y del producto. Te enviaremos una unidad de reposición sin coste adicional.",

        returns_right_title: "Derecho de desistimiento",
        returns_right: "Como consumidor, dispones de 14 días naturales desde la recepción del pedido para desistir del contrato, sin necesidad de justificación.\n\nPuedes ejercer este derecho de forma rápida desde nuestro formulario en línea: cortijodesantamaria.com/desistimiento. Al enviarlo, te llegará un acuse automático con un número de referencia y la fecha y hora exacta de recepción. También puedes comunicarlo por email a info@cortijodesantamaria.com indicando tu número de pedido.",
        returns_process_title: "Condiciones para AOVE y otras incidencias",
        returns_process: "Producto alimentario (AOVE): se admite el desistimiento de botellas que se nos devuelvan cerradas, precintadas y en condiciones aptas para reventa. Por motivos de higiene y seguridad alimentaria, no se admite el desistimiento de botellas abiertas, desprecintadas o que hayan perdido sus condiciones originales y no puedan revenderse.\n\nIncidencias distintas del desistimiento: si el producto llega dañado en el transporte, recibes una referencia equivocada o existe falta de conformidad respecto a lo descrito, no es un desistimiento. Escríbenos a info@cortijodesantamaria.com en las primeras 48 horas con fotografías del embalaje y del producto: lo gestionamos como reposición o reembolso sin coste, sin requisitos de apertura ni precinto.",
        returns_refund_title: "Reembolso",
        returns_refund: "Una vez confirmemos la procedencia del desistimiento, procesaremos el reembolso en un plazo máximo de 14 días naturales desde tu comunicación, por el mismo medio de pago utilizado en la compra.\n\nEn caso de devolución física, los gastos de envío de la devolución corren a cargo del cliente, salvo cuando el origen sea un producto defectuoso, dañado o un error por nuestra parte, en cuyo caso asumimos íntegramente el coste del retorno.",

        cookies_intro_title: "Qué cookies usamos",
        cookies_intro: "Este sitio utiliza exclusivamente cookies técnicas y, si das tu consentimiento, cookies analíticas. No utilizamos cookies publicitarias ni de seguimiento cruzado.",
        cookies_list_title: "Desglose",
        cookies_list_tech: "Cookies técnicas (siempre activas): necesarias para el funcionamiento del carrito, la sesión y el proceso de pago. Base legal: ejecución del contrato.",
        cookies_list_analytics: "Cookies analíticas (opcionales, requieren consentimiento): PostHog, para entender de forma anónima qué páginas se visitan y qué CTA funcionan mejor. Base legal: tu consentimiento.",
        cookies_table_headers: ["Nombre", "Tipo", "Finalidad", "Duración", "Terceros"],
        cookies_table_rows: [
          {
            name: "session_token",
            type: "Técnica",
            purpose: "Mantener la sesión del usuario y el carrito de la compra.",
            duration: "Sesión",
            third: "No",
          },
          {
            name: "cookieconsent o similar",
            type: "Técnica / Preferencia",
            purpose: "Recordar la preferencia de consentimiento de cookies del usuario.",
            duration: "1 año",
            third: "No",
          },
          {
            name: "posthog_* (ph_*)",
            type: "Analítica (opcional)",
            purpose: "Analítica web anónima: páginas visitadas y CTA más efectivos. Proveedor: PostHog (posthog.com).",
            duration: "1 año",
            third: "Sí — PostHog Inc. (EE. UU., con garantías adecuadas)",
          },
        ],
        cookies_withdraw_title: "Retirar el consentimiento",
        cookies_withdraw: "Puedes retirar tu consentimiento en cualquier momento borrando las cookies de tu navegador o escribiéndonos a info@cortijodesantamaria.com. La retirada del consentimiento no afecta a la licitud del tratamiento previo a la misma.",
      },
    },
    withdrawal: {
      overline: "Aviso legal",
      title: "Derecho de desistimiento",
      intro: "Como consumidor, dispones de 14 días naturales desde la recepción del pedido para desistir del contrato sin necesidad de justificación. Puedes comunicarlo aquí y nuestro equipo se pondrá en contacto contigo para confirmar la devolución y el reembolso.",
      form_title: "Comunicación de desistimiento",
      name_label: "Nombre y apellidos",
      email_label: "Email",
      order_label: "Número de pedido",
      products_label: "Productos afectados",
      products_help: "Indica qué referencias del pedido quieres devolver y la cantidad.",
      message_label: "Mensaje adicional (opcional)",
      declaration: "Declaro inequívocamente mi voluntad de desistir del contrato respecto de los productos indicados.",
      submit: "Enviar solicitud",
      success: "Hemos recibido tu solicitud. En breve nos pondremos en contacto contigo.",
      info_title: "Información práctica",
      info_period: "Plazo general: 14 días naturales desde la recepción del pedido.",
      info_refund: "Reembolso: en un máximo de 14 días desde la comunicación, por el mismo medio de pago utilizado.",
      info_aove: "Producto alimentario: por motivos de higiene y seguridad, no se admite el desistimiento de botellas abiertas o desprecintadas cuando no puedan revenderse.",
      info_damaged: "Producto dañado o erróneo: si el problema es una incidencia con el envío o con el producto, escríbenos a info@cortijodesantamaria.com y lo gestionamos como reposición sin coste, no como desistimiento.",
    },
    admin: {
      login_title: "Panel de administración",
      login_sub: "Acceso restringido a administradores.",
      email: "Email",
      password: "Contraseña",
      login: "Entrar",
      invalid_creds: "Credenciales incorrectas",
      logout: "Salir",
      dashboard_title: "Pedidos y stock",
      orders_tab: "Pedidos",
      products_tab: "Productos",
      customers_tab: "Clientes",
      blog_tab: "Diario",
      customers_title: "Clientes",
      customers_subtitle: "Agrupados por email. Se actualizan automáticamente con cada pedido.",
      customer_name: "Nombre",
      customer_email: "Email",
      customer_phone: "Teléfono",
      customer_location: "Localidad",
      customer_orders: "Pedidos",
      customer_paid: "Pagados",
      customer_spent: "Gasto total",
      customer_last_order: "Último pedido",
      customer_first_order: "Primer pedido",
      customer_address: "Dirección",
      customer_lang: "Idioma",
      view_orders: "Ver pedidos",
      hide_orders: "Ocultar pedidos",
      no_customers: "Aún no hay clientes.",
      order_number: "Pedido",
      date: "Fecha",
      customer: "Cliente",
      total: "Total",
      status: "Estado",
      actions: "Acciones",
      view: "Ver",
      update: "Actualizar",
      stock: "Stock",
      save: "Guardar",
      saved: "Guardado",
      no_orders: "Todavía no hay pedidos.",
      status_map: {
        pending_payment: "Pendiente de pago",
        pending_transfer: "Pendiente transferencia",
        paid: "Pagado",
        shipped: "Enviado",
        cancelled: "Cancelado",
        refunded: "Reembolsado",
      },
    },
  },
  en: {
    common: {
      back: "Back",
      continue: "Continue",
      loading: "Loading…",
      error_generic: "Something went wrong. Please try again.",
      required: "Required",
      eur: "€",
    },
    nav_ecom: {
      home: "Home",
      shop: "Shop",
      cart: "Cart",
      contact: "Contact",
      journal: "Journal",
    },
    shop_page: {
      overline: "Shop",
      title: "Early Harvest",
      subtitle: "Early-harvest extra virgin olive oil. Limited edition.",
      availability_banner: "Next harvest in preparation · join the waitlist.",
      add_to_cart: "Add to cart",
      view_product: "View product",
      out_of_stock: "Sold out",
      low_stock: "Last units",
      from_price: "From",
    },
    product_page: {
      qty: "Quantity",
      add_to_cart: "Add to cart",
      added: "Added to cart",
      in_stock: "In stock",
      low_stock: "Last units",
      out_of_stock: "Sold out",
      shipping_info: "Ships in 2-4 business days to mainland Spain. Protected packaging.",
      trust_1: "Limited edition · early harvest",
      trust_2: "Reinforced protective packaging · safe in transit",
      trust_3: "Secure payment · Stripe",
      trust_4: "Direct from the producer",
      details_title: "Product details",
      attributes_title: "Tech sheet",
      highlights_title: "Highlights",
      vat_included: "VAT included",
      availability_note: "Next harvest · availability pending confirmation.",
      bundle_title: "Choose the edition you are interested in",
      bundle_option_box: "Gift box only",
      bundle_option_box_1: "Box + 1 extra bottle",
      bundle_option_box_2: "Box + 2 extra bottles",
      bundle_summary_prefix: "Your selection:",
      bundle_micro: "One to gift, one for home.",
    },
    cart_page: {
      title: "Your cart",
      empty_title: "Your cart is empty",
      empty_body: "Browse our shop and add products to get started.",
      continue_shopping: "Continue shopping",
      go_shop: "Go to shop",
      item: "Item",
      price: "Price",
      qty: "Quantity",
      subtotal: "Subtotal",
      line_total: "Line total",
      remove: "Remove",
      summary: "Summary",
      shipping: "Shipping",
      shipping_calculated: "Calculated in the next step",
      total: "Total",
      checkout: "Checkout",
    },
    checkout_page: {
      title: "Order details",
      subtitle: "Fill in your shipping details and pick a payment method.",
      step_data: "Details",
      step_payment: "Payment",
      step_confirm: "Confirmation",
      customer_title: "Your details",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      address_title: "Shipping address",
      address1: "Address",
      address2: "Floor, door, landmark (optional)",
      city: "City",
      province: "Province",
      postal_code: "Postal code",
      country: "Country",
      country_locked_note: "At the moment, we can ship orders only to mainland Spain addresses.",
      notes: "Order notes (optional)",
      payment_title: "Payment method",
      payment_stripe: "Card / Apple Pay (Stripe)",
      payment_stripe_desc: "Secure card payment. Apple Pay and Google Pay if available on your device.",
      payment_paypal: "PayPal",
      payment_paypal_desc: "Coming soon.",
      payment_transfer: "Bank transfer",
      payment_transfer_desc: "We'll send you the bank details and hold your order for 72 h.",
      summary_title: "Order summary",
      terms_prefix: "I have read and accept the ",
      terms_link_aviso: "Terms of Use and Legal Notice",
      terms_and: " and the ",
      terms_link_privacy: "Privacy Policy",
      terms_suffix: ". I understand that my data will be processed to manage my order under art. 6.1.b GDPR.",
      place_order: "Place order",
      place_order_stripe: "Pay with card",
      place_order_transfer: "Confirm and pay by transfer",
      processing: "Processing…",
      missing_field: "Some required fields are missing.",
      must_accept: "You must accept the conditions.",
      cart_empty: "Your cart is empty.",
    },
    success_page: {
      title: "Thank you for your order!",
      subtitle: "Your purchase was received successfully.",
      paid: "Payment confirmed",
      processing: "Confirming your payment…",
      failed: "We couldn't confirm the payment.",
      order_number: "Order number",
      total: "Total",
      back_home: "Back to home",
      shop_more: "Continue shopping",
      withdrawal_title: "Right of withdrawal",
      withdrawal_body: "As a consumer, you have 14 calendar days from receipt of the order to withdraw from the contract.",
      withdrawal_cta: "Exercise right of withdrawal",
      withdrawal_note: "You can submit your request there and receive an automatic acknowledgement by email.",
    },
    transfer_page: {
      title: "Order reserved",
      subtitle: "Send the transfer within the next 3 business days and we'll ship your order.",
      beneficiary: "Account holder",
      iban: "IBAN",
      bic: "BIC / SWIFT",
      concept: "Reference",
      amount: "Amount",
      note: "Once we receive the transfer, we send you a confirmation email and prepare the shipment.",
    },
    cancelled_page: {
      title: "Payment cancelled",
      subtitle: "No charge has been made. You can return to the cart and try again.",
      back_cart: "Back to cart",
    },
    contact_page: {
      title: "Contact",
      subtitle: "We're in Limones, Moclín (Granada). We reply the same business day.",
      write_us: "Write to us",
      phone: "Phone",
      email: "Email",
      location: "Location",
      hours: "Hours",
      hours_text: "Mon–Fri · 9:00–18:00",
    },
    blog: {
      overline: "Journal",
      title: "The estate journal",
      subtitle:
        "Notes, tasting guides and gifting protocol. Short reads to enjoy EVOO with more criteria.",
      read_more: "Read article",
      read_time_suffix: "read",
      related_title: "More from the journal",
      all_posts: "See all articles",
      back_to_blog: "Back to journal",
      published_on: "Published on",
      updated_on: "Updated on",
      cta_title: "Want to try the EVOO we're writing about?",
      cta_body:
        "Limited early-harvest edition. 500 ml bottle or 2 × 500 ml wooden presentation box.",
      cta_shop: "Go to the shop",
      cta_product: "See the 500 ml bottle",
    },
    proof: {
      overline: "Facts behind the harvest",
      title_a: "What",
      title_b: "stands behind",
      title_c: "each bottle",
      body: "Concrete facts that define our family olive grove in Limones, Moclín.",
      metrics: [
        { k: "< 0.4°", v: "Free acidity", sub: "Well below the legal EVOO limit (0.8°). Verified by laboratory before bottling." },
        { k: "< 24 h", v: "Grove to mill", sub: "Every olive enters the mill the same day it is picked. No ground storage." },
        { k: "< 27 °C", v: "Cold extraction (below 27 °C)", sub: "Temperature controlled during milling to preserve polyphenols and volatile aromas." },
        { k: "100 %", v: "Picual", sub: "A characterful variety grown in our family grove in Limones, Moclín (Granada)." },
      ],
      credentials_title: "Product details",
      credentials: [
        "500 ml protective dark glass bottle, with dosing cap.",
        "Olives hand-picked in early November, always from the tree.",
        "Milled at a local mill on the same day of picking.",
        "Single origin: one family olive grove in Limones, Moclín. No blends.",
        "Store preferably below 23 °C and away from direct light.",
        "Consume within two months of opening; up to 24 months when properly stored.",
      ],
      panel_title: "Sensory profile · previous harvest reference",
      panel_attrs: [
        { k: "Fruitiness", v: "Intense", note: "Green and grassy, with tomato leaf and fig memories." },
        { k: "Bitterness", v: "Medium", note: "Noble bitterness typical of young picual, well integrated." },
        { k: "Pepperiness", v: "Medium-high", note: "Clean and persistent, at the back of the throat after a few seconds." },
        { k: "Finish", v: "Long", note: "Fresh almond and grassy memory." },
      ],
      panel_disclaimer: "Producer's sensory record · Cortijo Santa María · previous harvest reference. Not an external certification. Next edition pending confirmation.",
    },
    award: {
      alt: "Sabor Granada 2023 award certificate presented to Cortijo de Santa María as best organic EVOO",
      overline: "Recognition",
      title: "Sabor Granada Award 2023",
      body: "Cortijo de Santa María received the Best Organic Extra Virgin Olive Oil award at the 9th «Sabor Granada» EVOO Awards (2023), presented by the Provincial Council of Granada.",
      cta: "View the award certificate",
      cta_href: "/en/sabor-granada-award-2023",
    },
    legal: {
      aviso_title: "Legal notice",
      privacy_title: "Privacy policy",
      shipping_title: "Shipping policy",
      returns_title: "Returns & withdrawal policy",
      cookies_title: "Cookie policy",
      back_home: "Back to home",
      last_update: "Last update",
      sections: {
        holder: "Site holder",
        holder_body: "Cortijo de Santa María S.C. · Tax ID (NIF): J02704799 · Cortijo de Santa María s/n, 18249 Limones, Moclín (Granada), Spain · info@cortijodesantamaria.es · +34 626 411 029. Activity: direct-to-consumer sale of extra virgin olive oil from our own production.",
        aviso_purpose_title: "Purpose and acceptance",
        aviso_purpose: "This legal notice governs the use of the website cortijodesantamaria.com and its online store, owned by Cortijo Santa María. Accessing and using the site implies acceptance of these terms. If you disagree, please do not use the site.",
        aviso_ip_title: "Intellectual property",
        aviso_ip: "All site contents (text, images, logos, trademarks, photographs and graphic elements) are owned by Cortijo Santa María or used under licence. Reproduction, distribution or modification without express written authorisation is prohibited.",
        aviso_liability_title: "Liability",
        aviso_liability: "We take reasonable care to keep information accurate and up to date, but we cannot guarantee the absence of typographical errors or punctual stock availability. Prices are in euros, VAT included unless stated otherwise; shipping cost is calculated at checkout.",
        aviso_jurisdiction_title: "Law and jurisdiction",
        aviso_jurisdiction: "These terms are governed by Spanish law. For any dispute, both parties submit to the consumer courts of the buyer's domicile when the buyer has consumer status.",

        privacy_intro_title: "Who processes your data",
        privacy_intro: "The data controller is Cortijo Santa María, with address at Limones, Moclín, 18247 Granada (Spain). You can reach us at info@cortijodesantamaria.com for any question regarding your data.",
        privacy_purpose_title: "Why we use it",
        privacy_purpose: "We process your data solely to: (1) manage your orders and the purchase process, (2) prepare shipping and communicate about it, (3) issue invoices and comply with our tax and accounting obligations, and (4) answer enquiries. We do not carry out automated decisions with legal effect or build commercial profiles.",
        privacy_basis_title: "Legal basis",
        privacy_basis: "The basis for the processing is the performance of the sale contract (art. 6.1.b GDPR), compliance with legal obligations (art. 6.1.c GDPR) and, for optional analytics, your consent (art. 6.1.a GDPR), which you can withdraw at any time.",
        privacy_share_title: "Who we share it with",
        privacy_share: "We only share strictly necessary data with: the shipping carrier for delivery, the Stripe payment gateway to process the purchase (PCI-DSS certified processor), and our infrastructure provider for hosting. We never sell or assign your data to third parties for commercial purposes.",
        privacy_retention_title: "How long we keep it",
        privacy_retention: "We retain order data for the legal period required by tax and accounting regulations (up to 6 years). Data used for optional marketing is deleted if you withdraw consent.",
        privacy_rights: "You can exercise your rights of access, rectification, deletion, objection, limitation and portability by writing to info@cortijodesantamaria.com, proving your identity. You may also lodge a complaint with the Spanish Data Protection Agency (www.aepd.es) if you feel your request has not been properly addressed.",

        shipping_scope_title: "Scope and timing",
        shipping_scope: "Due to the new Packaging and Packaging Waste Regulation (PPWR, Regulation (EU) 2025/40), we currently ship exclusively to mainland Spain in 2-4 business days from payment confirmation. Shipments to the Balearic Islands, Canary Islands, Ceuta, Melilla, mainland Portugal and the rest of the European Union are temporarily suspended until further notice.",
        shipping_cost_title: "Shipping cost",
        shipping_cost: "Shipping is calculated automatically at checkout based on the number of bottles: €5 for one bottle, €8 for 2 to 5 bottles and €12 from 6 bottles upwards. Corporate or special orders are quoted separately.",
        shipping_package_title: "Packaging",
        shipping_package: "Every bottle travels sleeved in protective material inside a reinforced box. The gift case travels in an additional outer box. We include tamper-evident seals.",
        shipping_damage_title: "Damaged parcels",
        shipping_damage: "If you receive the parcel with visible damage, have the courier note it on the delivery slip and write to us within 48 hours at info@cortijodesantamaria.com with photos of the packaging and product. We will ship a replacement at no additional cost.",

        returns_right_title: "Right of withdrawal",
        returns_right: "As a consumer, you have 14 calendar days from receipt of the order to withdraw from the contract, without justification.\n\nYou can exercise this right quickly through our online form at cortijodesantamaria.com/desistimiento. When you submit it, you'll receive an automatic acknowledgement with a reference number and the exact date and time of receipt. You may also notify us by email at info@cortijodesantamaria.com indicating your order number.",
        returns_process_title: "Conditions for EVOO and other incidents",
        returns_process: "Food product (EVOO): withdrawal is accepted for bottles returned to us closed, sealed and in a condition suitable for resale. For hygiene and food-safety reasons, withdrawal is not accepted for bottles that have been opened, unsealed or have otherwise lost their original condition and cannot be resold.\n\nIncidents other than withdrawal: if the product arrives damaged in transit, you receive the wrong reference or there is any lack of conformity with what was described, this is not a withdrawal. Write to us at info@cortijodesantamaria.com within the first 48 hours with photos of the packaging and the product: we will handle it as a replacement or refund at no cost, with no opening or seal requirements.",
        returns_refund_title: "Refund",
        returns_refund: "Once the withdrawal is confirmed as eligible, we process the refund within a maximum of 14 calendar days from your communication, using the same payment method used for the purchase.\n\nIn the case of a physical return, return shipping costs are borne by the customer, except where the cause is a defective or damaged product or an error on our side, in which case we cover the full return cost.",

        cookies_intro_title: "Which cookies we use",
        cookies_intro: "This site uses only technical cookies and, if you consent, analytics cookies. We do not use advertising cookies or cross-site tracking.",
        cookies_list_title: "Breakdown",
        cookies_list_tech: "Technical cookies (always active): necessary for cart, session and payment process. Legal basis: contract performance.",
        cookies_list_analytics: "Analytics cookies (optional, require consent): PostHog, to understand anonymously which pages are visited and which CTAs work best. Legal basis: your consent.",
        cookies_table_headers: ["Name", "Type", "Purpose", "Duration", "Third party"],
        cookies_table_rows: [
          {
            name: "session_token",
            type: "Technical",
            purpose: "Maintain user session and shopping cart.",
            duration: "Session",
            third: "No",
          },
          {
            name: "cookieconsent or similar",
            type: "Technical / Preference",
            purpose: "Remember the user's cookie consent preference.",
            duration: "1 year",
            third: "No",
          },
          {
            name: "posthog_* (ph_*)",
            type: "Analytics (optional)",
            purpose: "Anonymous web analytics: pages visited and most effective CTAs. Provider: PostHog (posthog.com).",
            duration: "1 year",
            third: "Yes — PostHog Inc. (USA, with appropriate safeguards)",
          },
        ],
        cookies_withdraw_title: "Withdrawing consent",
        cookies_withdraw: "You can withdraw consent at any time by clearing your browser cookies or writing to info@cortijodesantamaria.com. Withdrawal does not affect the lawfulness of processing prior to it.",
      },
    },
    withdrawal: {
      overline: "Legal notice",
      title: "Right of withdrawal",
      intro: "As a consumer, you have 14 calendar days from receipt of the order to withdraw from the contract without justification. You can let us know here and our team will get in touch to confirm the return and the refund.",
      form_title: "Withdrawal communication",
      name_label: "Full name",
      email_label: "Email",
      order_label: "Order number",
      products_label: "Affected products",
      products_help: "Tell us which items from your order you want to return and the quantity.",
      message_label: "Additional message (optional)",
      declaration: "I unequivocally state my intention to withdraw from the contract regarding the products indicated above.",
      submit: "Send request",
      success: "We have received your request. We will get in touch with you shortly.",
      info_title: "Practical information",
      info_period: "General term: 14 calendar days from receipt of the order.",
      info_refund: "Refund: within a maximum of 14 days from your communication, using the same payment method as the purchase.",
      info_aove: "Food product: for hygiene and safety reasons, opened or unsealed bottles cannot be withdrawn when they cannot be resold.",
      info_damaged: "Damaged or wrong product: if the issue is a shipping or product incident, write to info@cortijodesantamaria.com and we handle it as a free replacement, not as a withdrawal.",
    },
    admin: {
      login_title: "Admin panel",
      login_sub: "Restricted access for administrators.",
      email: "Email",
      password: "Password",
      login: "Sign in",
      invalid_creds: "Invalid credentials",
      logout: "Sign out",
      dashboard_title: "Orders and stock",
      orders_tab: "Orders",
      products_tab: "Products",
      customers_tab: "Customers",
      blog_tab: "Journal",
      customers_title: "Customers",
      customers_subtitle: "Grouped by email. Updated automatically on every order.",
      customer_name: "Name",
      customer_email: "Email",
      customer_phone: "Phone",
      customer_location: "City",
      customer_orders: "Orders",
      customer_paid: "Paid",
      customer_spent: "Total spent",
      customer_last_order: "Last order",
      customer_first_order: "First order",
      customer_address: "Address",
      customer_lang: "Language",
      view_orders: "View orders",
      hide_orders: "Hide orders",
      no_customers: "No customers yet.",
      order_number: "Order",
      date: "Date",
      customer: "Customer",
      total: "Total",
      status: "Status",
      actions: "Actions",
      view: "View",
      update: "Update",
      stock: "Stock",
      save: "Save",
      saved: "Saved",
      no_orders: "No orders yet.",
      status_map: {
        pending_payment: "Pending payment",
        pending_transfer: "Pending transfer",
        paid: "Paid",
        shipped: "Shipped",
        cancelled: "Cancelled",
        refunded: "Refunded",
      },
    },
  },
};
